/** The product catalogue picker: starter products an owner copies into their shop. */
const catalog = {
  en: {
    open: "Add from catalogue",
    title: "Add products from the catalogue",
    intro: "Pick what you sell. Each product becomes your own, and you can change it later.",
    searchPlaceholder: "Search by name or brand…",
    allCategories: "All",
    template: "Catalogue",
    templateCount: "{copied} of {total} added",
    selectAll: "Select all shown",
    clearAll: "Clear selection",
    selected: { one: "{count} selected", other: "{count} selected" },
    add: { one: "Add {count} product", other: "Add {count} products" },
    adding: "Adding…",
    skip: "Skip for now",
    close: "Close",
    added: "Added",
    draftHint: "Products are added as drafts, with no price and no stock. They stay hidden from the register and the menu until you set your price and count your stock.",
    loadMore: "Show more",
    loading: "Loading…",
    empty: "Nothing matches your search.",
    noCatalogue: "The catalogue is empty for now. Products you add yourself will appear here once the catalogue grows.",
    loadFailed: "Could not load the catalogue.",
    copyFailed: "Could not add these products.",
    limitReached: "Your plan allows {limit} products. Remove some or ask for a bigger plan.",
    resultTitle: "Done!",
    resultAdded: { one: "{count} product added to your shop.", other: "{count} products added to your shop." },
    resultSkipped: { one: "{count} was already in your products and was left as it is.", other: "{count} were already in your products and were left as they are." },
    resultDrafts: { one: "{count} needs your price and stock before you can sell it.", other: "{count} need your price and stock before you can sell them." },
    resultNone: "Everything you picked was already in your products.",
    done: "Done",
    requestLink: "Can't find a product? Tell us",
    addAll: "Add this whole catalogue ({count})",
    addAllConfirm: "Add all {count} products of “{name}” to your shop? They are added as drafts, with no price and no stock.",
    requestTitle: "Tell us what is missing",
    requestHint: "Describe the product (name, brand, size…). We read every request and add what is missing.",
    requestBrand: "Brand (optional)",
    requestSend: "Send",
    requestSending: "Sending…",
    requestSent: "Thank you! We received your request.",
    requestFailed: "Could not send your request. Try again.",
  },
  fr: {
    open: "Ajouter depuis le catalogue",
    title: "Ajouter des produits depuis le catalogue",
    intro: "Choisissez ce que vous vendez. Chaque produit devient le vôtre et vous pourrez le modifier ensuite.",
    searchPlaceholder: "Rechercher par nom ou marque…",
    allCategories: "Tout",
    template: "Catalogue",
    templateCount: "{copied} sur {total} ajoutés",
    selectAll: "Tout sélectionner",
    clearAll: "Tout désélectionner",
    selected: { one: "{count} sélectionné", other: "{count} sélectionnés" },
    add: { one: "Ajouter {count} produit", other: "Ajouter {count} produits" },
    adding: "Ajout…",
    skip: "Passer pour l'instant",
    close: "Fermer",
    added: "Ajouté",
    draftHint: "Les produits sont ajoutés en brouillon, sans prix ni stock. Ils restent cachés de la caisse et du menu tant que vous n'avez pas fixé votre prix et compté votre stock.",
    loadMore: "Afficher plus",
    loading: "Chargement…",
    empty: "Aucun résultat pour votre recherche.",
    noCatalogue: "Le catalogue est vide pour le moment. Il se remplira au fil du temps.",
    loadFailed: "Impossible de charger le catalogue.",
    copyFailed: "Impossible d'ajouter ces produits.",
    limitReached: "Votre offre permet {limit} produits. Supprimez-en ou demandez une offre plus large.",
    resultTitle: "C'est fait !",
    resultAdded: { one: "{count} produit ajouté à votre boutique.", other: "{count} produits ajoutés à votre boutique." },
    resultSkipped: { one: "{count} était déjà dans vos produits et n'a pas été modifié.", other: "{count} étaient déjà dans vos produits et n'ont pas été modifiés." },
    resultDrafts: { one: "{count} a besoin de votre prix et de son stock avant de pouvoir être vendu.", other: "{count} ont besoin de votre prix et de leur stock avant de pouvoir être vendus." },
    resultNone: "Tout ce que vous avez choisi était déjà dans vos produits.",
    done: "Terminé",
    requestLink: "Un produit manque ? Dites-le-nous",
    addAll: "Ajouter tout ce catalogue ({count})",
    addAllConfirm: "Ajouter les {count} produits de « {name} » à votre boutique ? Ils sont ajoutés en brouillon, sans prix ni stock.",
    requestTitle: "Dites-nous ce qui manque",
    requestHint: "Décrivez le produit (nom, marque, taille…). Nous lisons chaque demande et ajoutons ce qui manque.",
    requestBrand: "Marque (facultatif)",
    requestSend: "Envoyer",
    requestSending: "Envoi…",
    requestSent: "Merci ! Nous avons bien reçu votre demande.",
    requestFailed: "Impossible d'envoyer votre demande. Réessayez.",
  },
  ar: {
    open: "إضافة من الكتالوج",
    title: "إضافة منتجات من الكتالوج",
    intro: "اختر ما تبيعه. يصبح كل منتج ملكًا لك ويمكنك تعديله لاحقًا.",
    searchPlaceholder: "ابحث بالاسم أو العلامة…",
    allCategories: "الكل",
    template: "الكتالوج",
    templateCount: "تمت إضافة {copied} من {total}",
    selectAll: "تحديد الكل",
    clearAll: "إلغاء التحديد",
    selected: { zero: "لا شيء محدد", one: "محدد {count}", two: "محدد {count}", few: "محدد {count}", many: "محدد {count}", other: "محدد {count}" },
    add: { zero: "إضافة", one: "إضافة منتج", two: "إضافة منتجين", few: "إضافة {count} منتجات", many: "إضافة {count} منتجًا", other: "إضافة {count} منتج" },
    adding: "جارٍ الإضافة…",
    skip: "تخطّي الآن",
    close: "إغلاق",
    added: "تمت الإضافة",
    draftHint: "تُضاف المنتجات كمسودات بلا سعر ولا مخزون. تبقى مخفية عن الصندوق والقائمة حتى تحدّد سعرك وتعدّ مخزونك.",
    loadMore: "عرض المزيد",
    loading: "جارٍ التحميل…",
    empty: "لا نتائج مطابقة لبحثك.",
    noCatalogue: "الكتالوج فارغ حاليًا. سيمتلئ مع الوقت.",
    loadFailed: "تعذّر تحميل الكتالوج.",
    copyFailed: "تعذّر إضافة هذه المنتجات.",
    limitReached: "تسمح باقتك بـ {limit} منتج. احذف بعضها أو اطلب باقة أكبر.",
    resultTitle: "تمّ!",
    resultAdded: { zero: "", one: "أُضيف منتج واحد إلى متجرك.", two: "أُضيف منتجان إلى متجرك.", few: "أُضيفت {count} منتجات إلى متجرك.", many: "أُضيف {count} منتجًا إلى متجرك.", other: "أُضيف {count} منتج إلى متجرك." },
    resultSkipped: { zero: "", one: "كان منتج واحد موجودًا في منتجاتك وتُرك كما هو.", two: "كان منتجان موجودين في منتجاتك وتُركا كما هما.", few: "كانت {count} منتجات موجودة في منتجاتك وتُركت كما هي.", many: "كان {count} منتجًا موجودًا في منتجاتك وتُرك كما هو.", other: "كان {count} منتج موجودًا في منتجاتك وتُرك كما هو." },
    resultDrafts: { zero: "", one: "منتج واحد يحتاج إلى سعرك ومخزونك قبل بيعه.", two: "منتجان يحتاجان إلى سعرك ومخزونك قبل بيعهما.", few: "{count} منتجات تحتاج إلى سعرك ومخزونها قبل بيعها.", many: "{count} منتجًا يحتاج إلى سعرك ومخزونه قبل بيعه.", other: "{count} منتج يحتاج إلى سعرك ومخزونه قبل بيعه." },
    resultNone: "كل ما اخترته كان موجودًا في منتجاتك.",
    done: "تم",
    requestLink: "لم تجد منتجًا؟ أخبرنا",
    addAll: "إضافة هذا الكتالوج كاملًا ({count})",
    addAllConfirm: "إضافة المنتجات الـ {count} من «{name}» إلى متجرك؟ تُضاف المنتجات كمسودات بلا سعر ولا مخزون.",
    requestTitle: "أخبرنا بما ينقص",
    requestHint: "صِف المنتج (الاسم، العلامة، الحجم…). نقرأ كل طلب ونضيف ما ينقص.",
    requestBrand: "العلامة (اختياري)",
    requestSend: "إرسال",
    requestSending: "جارٍ الإرسال…",
    requestSent: "شكرًا! وصلنا طلبك.",
    requestFailed: "تعذّر إرسال طلبك. حاول مرة أخرى.",
  },
};

export default catalog;
